import { useEffect, useState } from 'react'
import { db } from 'utils/firebase'
import { firebaseCollections as collections } from 'utils/constants'

export default function useSubscribeToRentalItems (currentRental = {}) {
  const [loading, setLoading] = useState(true)
  const  [rentalItems, setRentalItems ] = useState(currentRental?.items ?? [])
  const [error, ] = useState('')
  useEffect(() => {
    let unsubscribe = () => {}
    if (currentRental && currentRental?.id) {
      unsubscribe = db.collection(collections.rentals)
      .doc(currentRental?.id)
      .collection(collections.items)
      .onSnapshot(querySnapshot => {
        setLoading(true)
        let items = []
        querySnapshot.forEach(doc => {
          let item = { id: doc.id, ...doc.data() }
          items.push(item)
        })
        setRentalItems(items)
        setLoading(false)
      })
    } else {
      setRentalItems([])
    }
    return () => {
      unsubscribe()
    }
  }, [currentRental?.id])
  return { loading, error, items: rentalItems }
}